import { render, staticRenderFns } from "./AutoprovisioningForm.vue?vue&type=template&id=88fb5454&scoped=true"
import script from "./AutoprovisioningForm.vue?vue&type=script&lang=js"
export * from "./AutoprovisioningForm.vue?vue&type=script&lang=js"
import style0 from "./AutoprovisioningForm.vue?vue&type=style&index=0&id=88fb5454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb5454",
  null
  
)

export default component.exports